<!-- <app-notifications [class]="showNotification() ? 'fadeIn' : 'fadeOut'" /> -->
<app-notifications />

@if (location.path() !== '') {
    @if (initialized) {
        <app-header [routeName]="routeName"></app-header>
    }
    <app-sidebar (setRouteName)="setRouteName($event)" [routeName]="routeName"></app-sidebar>
}

<router-outlet></router-outlet>